"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useChannelsUnread = useChannelsUnread;
var _react = require("react");
var _utils = require("./utils");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// we cannot take and track activeChannels from ChatContext because it is only available
// in Chat but we need to track it on all the pages, e.g. to show green dot
function useChannelsUnread(_ref) {
  var client = _ref.client,
    channels = _ref.channels;
  var _useState = (0, _react.useState)({
      total: 0,
      oneToOneChannels: 0,
      groupChannels: 0,
      communityChannels: 0
    }),
    _useState2 = _slicedToArray(_useState, 2),
    unreadMessages = _useState2[0],
    setUnreadMessages = _useState2[1];
  var _useState3 = (0, _react.useState)({
      total: 0,
      groupChannels: 0,
      communityChannels: 0
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    unreadMentions = _useState4[0],
    setUnreadMentions = _useState4[1];
  var setUnread = function setUnread(totalUnreadCount) {
    // threads are `my` threads (parent message is created by the current user) which were not read yet
    var threads = (0, _utils.calculateUnreadThreadsCountsFromChannels)(client, channels);
    var messages = (0, _utils.calculateUnreadMessagesCountsFromChannels)(client, channels, totalUnreadCount);
    var mentions = (0, _utils.calculateUnreadMentionsCountsFromChannels)(client, channels, totalUnreadCount);
    setUnreadMessages({
      total: messages.total + threads.total,
      oneToOneChannels: messages.oneToOneChannels,
      groupChannels: messages.groupChannels + threads.groupChannels,
      communityChannels: messages.communityChannels + threads.communityChannels
    });
    setUnreadMentions({
      total: mentions.total + threads.total,
      groupChannels: mentions.groupChannels + threads.groupChannels,
      communityChannels: mentions.communityChannels + threads.communityChannels
    });
  };
  var clientListener = (0, _react.useCallback)(function (event) {
    var _event$me, _event$member;
    var isMessageEvent = event.type.includes('message');
    var isMyChannelMute = event.type === 'notification.channel_mutes_updated' && ((_event$me = event.me) === null || _event$me === void 0 ? void 0 : _event$me.id) === client.userID;
    var isMyChannelMembershipChange = ['member.removed', 'member.added'].includes(event.type) && ((_event$member = event.member) === null || _event$member === void 0 ? void 0 : _event$member.user_id) === client.userID;
    if (isMessageEvent || isMyChannelMute || isMyChannelMembershipChange) {
      setUnread(event.total_unread_count);
    }
  }, [client, channels]);
  (0, _react.useEffect)(function () {
    if (!client) {
      return;
    }
    client.on(clientListener);

    // pass 1 instead of client.user.total_unread_count to trigger calculation
    // because client.user.total_unread_count is currently broken
    // setUnread(client.user.total_unread_count);
    setUnread(1);
    return function () {
      client.off(clientListener);
    };
  }, [client, channels]);
  return {
    unreadMessages: unreadMessages,
    unreadMentions: unreadMentions
  };
}